import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { getFullPath } from '@app/utilities';

export interface CustomNavigateProps {
  to: string;
}

/** Redirect to a new path and keep extra things like hash in the path. */
export const CustomNavigate: FC<CustomNavigateProps> = ({
  to
}) => {
  if (to[to.length -1] !== '/') {
    to += '/';
  }

  return <Navigate to={getFullPath(to)} />;
};
